<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4">
    <h1 class="center">
      <mat-icon class="text-danger mr-1" style="margin-right: 6px;color: rgb(202,1,1);font-size: 28px; width:  28px;">
        auto_stories</mat-icon>
      Logs
    </h1>
  </div>
</div> -->

<div class="container-fluid">
  <div class="row">
    <app-logging class="col-sm-12"></app-logging>
  </div>
</div>
